<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/companies']">Empresas</a></li>
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
<p-card header="Filtros">
    <div class="p-grid">
        <div class="p-col p-field">
            <label for="name">Nombre</label>
            <input id="name" type="text" pInputText [(ngModel)]="companiesFilters.name" />
        </div>
        <div class="p-col-4 p-field">
            <label for="vat_number">CIF</label>
            <input id="vat_number" type="text" pInputText [(ngModel)]="companiesFilters.vat_number" />
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col p-ai-right">
            <p-button label="Limpiar filtros" (click)="clearFilters()" styleClass="p-button-secondary"></p-button>
            <p-button label="Buscar" (click)="search()" class="p-ml-2"></p-button>
        </div>
    </div>
</p-card>
<p-card styleClass="p-card-content-fit">
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Empresas
            <div class="p-card-title-actions">
                <a (click)="edit({ id: 0 })"><fa-icon [icon]="['fas', 'plus-circle']"></fa-icon> Nueva empresa</a>
            </div>
        </div>
    </ng-template>
    <p-table #grid [value]="companies" 
        [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
        [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true" 
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas" [rowsPerPageOptions]="[5,10,25,50]" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="id" width="100">ID</th>
                <th pSortableColumn="name">Nombre</th>
                <th pSortableColumn="vat_number" width="200">CIF</th>
                <th width="100"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-company>
            <tr (dblclick)="edit(company)">
                <td>{{company.id}}</td>
                <td>{{company.name}}</td>
                <td>{{company.vat_number}}</td>
                <td class="grid-actions">
                    <a (click)="edit(company)"><fa-icon [icon]="['far', 'edit']"></fa-icon></a>
                    <a (click)="delete(company)" class="color-danger"><fa-icon [icon]="['far', 'trash-alt']"></fa-icon></a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
